var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiniLogoRunway(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.693 0a3.087 3.087 0 00-3.091 3.086v13.155h2.636V3.086a.447.447 0 01.447-.445h.819V0h-.81zM36.002 16.693a3.085 3.085 0 00-3.086-3.084H19.758v2.632h13.158a.446.446 0 01.447.446v.82h2.64v-.814zM19.31 0a3.087 3.087 0 013.084 3.086v9.541h-2.636v-9.54a.445.445 0 00-.445-.446h-.82V0h.816zM36.002 19.312a3.087 3.087 0 01-3.086 3.087h-9.541v-2.642h9.54a.447.447 0 00.448-.447v-.819h2.64v.821zM0 19.312A3.084 3.084 0 003.085 22.4h13.158v-2.642H3.085a.445.445 0 01-.446-.447v-.819H0v.821zM0 16.693a3.083 3.083 0 013.085-3.084h9.54v2.632h-9.54a.447.447 0 00-.446.446v.82H0v-.814zM19.31 36a3.085 3.085 0 003.084-3.084V19.758h-2.636v13.158a.445.445 0 01-.445.445h-.82v2.64h.816zM16.693 36a3.085 3.085 0 01-3.091-3.085v-9.54h2.636v9.54a.447.447 0 00.447.445h.819V36h-.81z",
    fill: "#AAC4F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniLogoRunway);
export default __webpack_public_path__ + "static/media/miniLogoRunway.6f347de3980f164380fac7b42a15e639.svg";
export { ForwardRef as ReactComponent };